// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.legend-block {
  display: flex;
  row-gap: 2px;
  flex-direction: column;
}
.legend-block.checkable {
  margin-left: -4px;
}
.legend-block.uncheckable {
  margin-left: 0;
}
.legend-block .legend-item {
  display: flex;
  align-items: center;
  margin-left: 7px;
}
.legend-block > .legend-symbol {
  display: flex;
  column-gap: 6px;
  align-items: center;
  min-height: 20px;
  font-size: 13px;
  line-height: 20px;
}
.legend-block > .legend-symbol > .ant-checkbox-wrapper {
  align-self: start;
}
.legend-block > .legend-symbol > .legend-title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.legend-block > .legend-symbol .ant-checkbox-checked .ant-checkbox-inner {
  border-color: #d9d9d9;
  border: dotted #d9d9d9 0.005em;
}
.legend-block > .legend-symbol .ant-checkbox .ant-checkbox-inner {
  border-color: #d9d9d9;
  border: dotted #d9d9d9 0.005em;
}
`, "",{"version":3,"sources":["webpack://./package/nextgisweb/nextgisweb/webmap/nodepkg/layers-tree/Legend.less"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,YAAA;EACA,sBAAA;AACJ;AACI;EACI,iBAAA;AACR;AAEI;EACI,cAAA;AAAR;AAVA;EAcQ,aAAA;EACA,mBAAA;EACA,gBAAA;AADR;AAfA;EAoBQ,aAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAFR;AAvBA;EA4BY,iBAAA;AAFZ;AA1BA;EAgCY,gBAAA;EACA,uBAAA;EACA,mBAAA;AAHZ;AA/BA;EAsCY,qBAAA;EACA,8BAAA;AAJZ;AAnCA;EA2CY,qBAAA;EACA,8BAAA;AALZ","sourcesContent":[".legend-block {\n    display: flex;\n    row-gap: 2px;\n    flex-direction: column;\n\n    &.checkable {\n        margin-left: -4px;\n    }\n\n    &.uncheckable {\n        margin-left: 0;\n    }\n\n    .legend-item {\n        display: flex;\n        align-items: center;\n        margin-left: 7px;\n    }\n    \n    > .legend-symbol {\n        display: flex;\n        column-gap: 6px;\n        align-items: center;\n        min-height: 20px;\n        font-size: 13px;\n        line-height: 20px;\n\n        > .ant-checkbox-wrapper {\n            align-self: start;\n        }\n\n        > .legend-title {\n            overflow: hidden;\n            text-overflow: ellipsis;\n            white-space: nowrap;\n        }\n\n        .ant-checkbox-checked .ant-checkbox-inner {\n            border-color: #d9d9d9;\n            border: dotted #d9d9d9 0.005em;\n        }\n\n        .ant-checkbox .ant-checkbox-inner {\n            border-color: #d9d9d9;\n            border: dotted #d9d9d9 0.005em;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
